export default __webpack_public_path__ + "static/media/last-map-update.0aabcec1.jpg";